 //import React, { useState } from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import TableSortLabel from "@mui/material/TableSortLabel";
// import Paper from "@mui/material/Paper";
// import { Box, Chip, Typography } from "@mui/material";
// //import FilterPopup from "./FilterPopup";
// // Make sure Pagination.tsx exists in the same folder or update the path accordingly
// import PaginationComponent from "./Pagination";
// import FilterTags from "./FilterTags";
// import SortingArrow from "../../../src/assests/images/Sorting.svg";


// interface RowData {
//   id: number;
//   pmpmiEntityCodei: string;
//   retailerName: string;
//   outletName: string;
//   location: string;
//   reassignCount: string;
//   status: string;
//   submittedOn: string;
//   rejectReason: string;
//   points: string;
//   asm: string;
//   distribution: string;
//   salesVolume: string;
// }

// const AssignTotalUserTable: React.FC = () => {
//   const [order, setOrder] = useState<"asc" | "desc">("asc");
//   const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
//   const [filter, setFilter] = useState();

//   const rows: RowData[] = [
//     {
//       id: 1,
//       pmpmiEntityCodei: "12345id",
//       retailerName: "Aman",
//       outletName: "Aman Pan Shop",
//       location: "Delhi",
//       reassignCount: "10",
//       status: "Rejected",
//       submittedOn: "17 Sep 2024",
//       rejectReason: "Image Upload",
//       points: "300",
//       asm: "Aman Pan Shop",
//       distribution: "XYZ",
//       salesVolume: "Approved",
//     },
//     {
//       id: 2,
//       pmpmiEntityCodei: "12345id",
//       retailerName: "Aman",
//       outletName: "San Pan Shop",
//       location: "Delhi",
//       reassignCount: "12",
//       status: "Completed",
//       submittedOn: "17 Sep 2024",
//       rejectReason: "Image Upload",
//       points: "300",
//       asm: "Setu Pan Shop",
//       distribution: "XYZ",
//       salesVolume: "Approved",
//     },
//     {
//       id: 3,
//       pmpmiEntityCodei: "12347id",
//       retailerName: "Aman",
//       outletName: "Srinish Pan Shop",
//       location: "Delhi",
//       reassignCount: "115",
//       status: "Not Started",
//       submittedOn: "17 Sep 2024",
//       rejectReason: "Image Upload",
//       points: "300",
//       asm: "DM Pan Shop",
//       distribution: "XYZ",
//       salesVolume: "Approved",
//     }
//   ];

//   const handleSort = (property: keyof RowData) => {
//     const isAsc = orderBy === property && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);
//   };

//   const sortedRows = [...rows].sort((a, b) => {
//     if (!orderBy) return 0;

//     let aVal: string | number = a[orderBy];
//     let bVal: string | number = b[orderBy];

//     // Convert date strings to timestamps for sorting
//     if (orderBy === "pmpmiEntityCodei") {
//       aVal = new Date(aVal).getTime();
//       bVal = new Date(bVal).getTime();
//     }

//     if (aVal < bVal) return order === "asc" ? -1 : 1;
//     if (aVal > bVal) return order === "asc" ? 1 : -1;
//     return 0;
//   });
//   const getStatusColor = (status: string) => {
//     switch (status.toLowerCase()) {
//       case "not started":
//         return { bg: "#E0E0E0", color: "#5A5A5A" };
//       case "opened":
//         return { bg: "#FFF4E5", color: "#FFA000" };
//       case "approval pending":
//         return { bg: "#E6F0FF", color: "#1976D2" };
//       case "completed":
//         return { bg: "#E9F6EC", color: "#2E7D32" };
//       case "rejected":
//         return { bg: "#FFECEC", color: "#D32F2F" };
//       case "delayed":
//         return { bg: "#EEEEEE", color: "#616161" };
//       case "on hold":
//         return { bg: "#FFF7E0", color: "#F9A825" };
//       case "cancelled":
//         return { bg: "#E3F2FD", color: "#1565C0" };
//       default:
//         return { bg: "#F0F0F0", color: "#333" };
//     }
//   };


  
//   return (
//     <Box sx={{
//       background: "#F9FBFC", marginTop: "20px", marginBottom: "50px"
//     }}>
//       < Box sx={{
//         padding: "0px", borderRadius: "10px",
//         border: "1px solid rgb(224, 226, 227)", boxShadow: "-1px 1px 1px #e7e8e9"
//       }}>
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             background: "#fff",
//             borderRadius: "10px"

//           }}
//         >
//           <Typography
//             variant="h3"
//             sx={{
//               fontSize: "18px",
//               color: "#282829",
//               fontWeight: "600",
//               padding: "20px",
//               background: "#fff",
//               borderTopLeftRadius: "10px",
//               borderTopRightRadius: "10px",
//             }}
//           >
//             Total Users( 3000 Users )
//           </Typography>

//         </Box>
//         <Box sx={{ background: "#fff", paddingBottom: "20px" }}>
//           <Typography sx={{ paddingLeft: "20px" }}>
//             <FilterTags title={"Applied Filters :"} />
//           </Typography>
//         </Box>
//         <TableContainer component={Paper} sx={{
//           maxHeight: "400px", // Add scroll if needed
//           overflow: "auto",
//           "&::-webkit-scrollbar": {
//             width: "5px", // Thin scrollbar
//             height: "5px"
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "#B0B0B0", // Scroll thumb color
//             borderRadius: "3px"
//           },
//           "&::-webkit-scrollbar-track": {
//             backgroundColor: "#f0f0f0", // Track color
//             borderRadius: "3px"
//           }
//         }}>
//           <Table sx={{ minWidth: 650 }} aria-label="sortable table">
//             <TableHead sx={{ background: "#EEF4FF" }}>
//               <TableRow>

//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "pmpmiEntityCodei"}
//                     direction={orderBy === "pmpmiEntityCodei" ? order : "asc"}
//                     onClick={() => handleSort("pmpmiEntityCodei")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                     sx={{ opacity: 1 }}
//                   >
//                     PMI Entity Code
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "retailerName"}
//                     direction={orderBy === "retailerName" ? order : "asc"}
//                     onClick={() => handleSort("retailerName")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Retailer Name
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "outletName"}
//                     direction={orderBy === "outletName" ? order : "asc"}
//                     onClick={() => handleSort("outletName")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Outlet Name
//                   </TableSortLabel>
//                 </TableCell>

//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "location"}
//                     direction={orderBy === "location" ? order : "asc"}
//                     onClick={() => handleSort("location")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Location
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "reassignCount"}
//                     direction={orderBy === "reassignCount" ? order : "asc"}
//                     onClick={() => handleSort("reassignCount")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Reassign Count
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "status"}
//                     direction={orderBy === "status" ? order : "asc"}
//                     onClick={() => handleSort("status")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Status
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "submittedOn"}
//                     direction={orderBy === "submittedOn" ? order : "asc"}
//                     onClick={() => handleSort("submittedOn")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Submitted On
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "rejectReason"}
//                     direction={orderBy === "rejectReason" ? order : "asc"}
//                     onClick={() => handleSort("rejectReason")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Reject Reason
//                   </TableSortLabel>
//                 </TableCell>

//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "points"}
//                     direction={orderBy === "points" ? order : "asc"}
//                     onClick={() => handleSort("points")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Points
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "asm"}
//                     direction={orderBy === "asm" ? order : "asc"}
//                     onClick={() => handleSort("asm")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     ASM
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "distribution"}
//                     direction={orderBy === "distribution" ? order : "asc"}
//                     onClick={() => handleSort("distribution")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Distributors
//                   </TableSortLabel>
//                 </TableCell>
//                 <TableCell>
//                   <TableSortLabel
//                     active={orderBy === "salesVolume"}
//                     direction={orderBy === "salesVolume" ? order : "asc"}
//                     onClick={() => handleSort("salesVolume")}
//                     IconComponent={() => (
//                       <img
//                         src={SortingArrow}
//                         alt="Sort Icon"
//                         style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }} // ensure icon is always visible
//                       />
//                     )}
//                   >
//                     Sales Voume
//                   </TableSortLabel>
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {sortedRows.map((row, index) => (
//                 <TableRow
//                   key={row.id}
//                   sx={{ "&:last-child td, &:last-child th": { border: 0 }, backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent", }}
//                 >

//                   <TableCell>{row.pmpmiEntityCodei}</TableCell>
//                   <TableCell>{row.retailerName}</TableCell>
//                   <TableCell>{row.outletName}</TableCell>
//                   <TableCell>{row.location}</TableCell>
//                   <TableCell>{row.reassignCount}</TableCell>
//                   <TableCell>
//                     {/* {row.status} */}
//                     <Chip
//                       label={row.status}
//                       size="small"
//                       sx={{
//                         fontWeight: 600,
//                         fontSize: "12px",
//                         backgroundColor: getStatusColor(row.status).bg,
//                         color: getStatusColor(row.status).color,
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell>{row.submittedOn}</TableCell>
//                   <TableCell>{row.points}</TableCell>
//                   <TableCell>{row.reassignCount}</TableCell>
//                   <TableCell>{row.asm}</TableCell>
//                   <TableCell>{row.distribution}</TableCell>
//                   <TableCell>{row.salesVolume}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box >
//       <Box
//         sx={{
//           padding: "10px 10px",
//           background: "#fff",
//           border: "1px solid #dadada",
//           margin: "0px",
//           borderBottomLeftRadius: "10px",
//           borderBottomRightRadius: "10px",
//           boxShadow: "-1px 1px 1px #e7e8e9"
//         }}
//       >
//         <PaginationComponent />
//       </Box>
//     </Box >
//   );
// };

// export default AssignTotalUserTable;
// AssignTotalUserTable.tsx
import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { Box, Chip, Typography } from "@mui/material";
import PaginationComponent from "./Pagination";
import FilterTags from "./FilterTags";
import SortingArrow from "../../../src/assests/images/Sorting.svg";
import {gettaskData}  from "./api";
import { useParams } from "react-router-dom";

interface RowData {
  id: number;
  pmpmiEntityCodei: string;
  retailerName: string;
  outletName: string;
  location: string;
  reassignCount: string;
  status: string;
  submittedOn: string;
  rejectReason: string;
  points: string;
  asm: string;
  distribution: string;
  salesVolume: string;
}

const AssignTotalUserTable: React.FC<{ taskId: string; token: string }> = ({ taskId, token }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
  const [rows, setRows] = useState<RowData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
 const {maintaskid,taskType } = useParams();

   const [page, setPage] = useState(1);
   const [totallengthcount, settotallength] = useState(0);


   const perpagedata = 10;


 useEffect(() => {
if (!maintaskid || !taskType) return;

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await gettaskData({ task_id: maintaskid, page, limit: perpagedata , task_type: taskType || ""}, token);
const data: RowData[] = response.data.data.paginatedResults.map((item: any, index: number) => ({
  id: index + 1,
  pmpmiEntityCodei: item.pmi_entity_code || "",
  retailerName: item.retailer_name || "",   // Match API field
  outletName: item.outlet_name || "",
  location: item.location || "",           // Match API field
  reassignCount: "0",                        // API does not provide, default to 0
  status: "",                                // API does not provide
  submittedOn: "",                           // API does not provide
  rejectReason: "",                          // API does not provide
  points: "0",                               // API does not provide
  asm: "",                                   // API does not provide
  distribution: "",                          // API does not provide
  salesVolume: "",                           // API does not provide
}));
console.log("API Response:", response.data);

      setRows(data);
settotallength(response.data.data.total_users)
    } catch (error) {
      console.error("Error fetching task data:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [maintaskid, token,page,perpagedata,taskType]);


  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedRows = [...rows].sort((a, b) => {
    if (!orderBy) return 0;
    const aVal = a[orderBy];
    const bVal = b[orderBy];
    if (aVal < bVal) return order === "asc" ? -1 : 1;
    if (aVal > bVal) return order === "asc" ? 1 : -1;
    return 0;
  });

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "not started":
        return { bg: "#E0E0E0", color: "#5A5A5A" };
      case "opened":
        return { bg: "#FFF4E5", color: "#FFA000" };
      case "approval pending":
        return { bg: "#E6F0FF", color: "#1976D2" };
      case "completed":
        return { bg: "#E9F6EC", color: "#2E7D32" };
      case "rejected":
        return { bg: "#FFECEC", color: "#D32F2F" };
      case "delayed":
        return { bg: "#EEEEEE", color: "#616161" };
      case "on hold":
        return { bg: "#FFF7E0", color: "#F9A825" };
      case "cancelled":
        return { bg: "#E3F2FD", color: "#1565C0" };
      default:
        return { bg: "#F0F0F0", color: "#333" };
    }
  };

  if (loading) return <Typography sx={{ padding: 2 }}>Loading...</Typography>;

  const limit = 10;
const totalPages = Math.ceil(totallengthcount / limit);

console.log(rows,"rowsssssssssssssssssssssssssssssssssssssssssssssssssssssssss" )
  return (
    <Box sx={{ background: "#F9FBFC", marginTop: "20px", marginBottom: "50px" }}>
      <Box sx={{ padding: "0px", borderRadius: "10px", border: "1px solid rgb(224, 226, 227)", boxShadow: "-1px 1px 1px #e7e8e9" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", borderRadius: "10px" }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: "18px",
              color: "#282829",
              fontWeight: "600",
              padding: "20px",
              background: "#fff",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            Total Users ({totallengthcount} Users)
          </Typography>
        </Box>

        {/* <Box sx={{ background: "#fff", paddingBottom: "20px" }}>
          <Typography sx={{ paddingLeft: "20px" }}>
            <FilterTags title={"Applied Filters :"} />
          </Typography>
        </Box> */}

        <TableContainer component={Paper} sx={{ maxHeight: "400px", overflow: "auto" }}>
          <Table sx={{ minWidth: 650 }} aria-label="sortable table">
            <TableHead sx={{ background: "#EEF4FF" }}>
              <TableRow>
                {[
                  { key: "pmpmiEntityCodei", label: "PMI Entity Code" },
                  { key: "retailerName", label: "Retailer Name" },
                  { key: "outletName", label: "Outlet Name" },
                  { key: "location", label: "Location" },
                  // { key: "reassignCount", label: "Reassign Count" },
                  // { key: "status", label: "Status" },
                  // { key: "submittedOn", label: "Submitted On" },
                  // { key: "points", label: "Points" },
                  // { key: "asm", label: "ASM" },
                  // { key: "distribution", label: "Distributors" },
                  // { key: "salesVolume", label: "Sales Volume" },
                ].map((col) => (
                  <TableCell key={col.key}>
                    <TableSortLabel
                      active={orderBy === col.key}
                      direction={orderBy === col.key ? order : "asc"}
                      onClick={() => handleSort(col.key as keyof RowData)}
                      IconComponent={() => (
                        <img
                          src={SortingArrow}
                          alt="Sort Icon"
                          style={{ width: 16, height: 16, opacity: 1, marginLeft: "5px" }}
                        />
                      )}
                    >
                      {col.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {sortedRows.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent",
                  }}
                >
                  <TableCell>{row.pmpmiEntityCodei}</TableCell>
                  <TableCell>{row.retailerName}</TableCell>
                  <TableCell>{row.outletName}</TableCell>
                  <TableCell>{row.location}</TableCell>
                  {/* <TableCell>{row.reassignCount}</TableCell> */}
                  {/* <TableCell>
                    <Chip
                      label={row.status}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        backgroundColor: getStatusColor(row.status).bg,
                        color: getStatusColor(row.status).color,
                      }}
                    />
                  </TableCell>
                  <TableCell>{row.submittedOn}</TableCell>
                  <TableCell>{row.points}</TableCell>
                  <TableCell>{row.asm}</TableCell>
                  <TableCell>{row.distribution}</TableCell>
                  <TableCell>{row.salesVolume}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            padding: "10px",
            background: "#fff",
            border: "1px solid #dadada",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            boxShadow: "-1px 1px 1px #e7e8e9",
          }}
        >
         <PaginationComponent
  page={page}
  limit={limit} // optional if you want to use it for fetching data
  totalPages={totalPages}
  onPageChange={(newPage) => setPage(newPage)}
/>
        </Box>
      </Box>
    </Box>
  );
};

export default AssignTotalUserTable;